const workbenchTab = {
    path: '/admin/workbench',
    fullPath: '/admin/workbench',
    name: 'workbench',
    title: '工作台',
    affix: true,
}

function formatTab(route) {
    return {
        path: route.meta && route.meta.tabPath ? route.meta.tabPath : route.path,
        fullPath: route.meta && route.meta.tabPath ? route.meta.tabPath : route.fullPath || route.path,
        name: route.name,
        title: route.meta && route.meta.title ? route.meta.title : route.name,
        affix: Boolean(route.meta && route.meta.affix),
    }
}

export default {
    namespaced: true,
    state: {
        visitedTabs: [workbenchTab],
    },
    mutations: {
        ADD_VISITED_TAB(state, route) {
            if (!route || !route.name || !route.meta || !route.meta.title) return

            const tab = formatTab(route)
            if (state.visitedTabs.some((item) => item.path === tab.path)) return

            state.visitedTabs.push(tab)
        },
        DEL_VISITED_TAB(state, tab) {
            if (!tab || tab.affix) return

            state.visitedTabs = state.visitedTabs.filter((item) => item.path !== tab.path)
        },
        RESET_VISITED_TABS(state) {
            state.visitedTabs = [workbenchTab]
        },
    },
    actions: {
        addVisitedTab({ commit }, route) {
            commit('ADD_VISITED_TAB', route)
        },
        delVisitedTab({ commit }, tab) {
            commit('DEL_VISITED_TAB', tab)
        },
        resetVisitedTabs({ commit }) {
            commit('RESET_VISITED_TABS')
        },
    },
}
